/* eslint-disable functional/prefer-tacit */

import { useLocation as useLocationActual } from "react-router-dom";

export function useLocation() {
  return useLocationActual();
}
